import React, { Component } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { Typeahead } from 'react-bootstrap-typeahead';
import { toast } from 'react-toastify';

// Validation schema
const validationSchema = Yup.object({
  quality_level: Yup.number()
    .required('Quality level is required')
    .positive('Quality level must be positive')
    .integer('Quality level must be an integer'),
});

// Custom input component
const CustomInput = ({ field, form, ...props }) => {
  const hasError = form.touched[field.name] && form.errors[field.name];

  return (
    <div className={props.parentClass || 'form-group'}>
      <input
        {...field}
        {...props}
        className={`${props.className || 'form-control'} ${hasError ? 'error' : ''}`}
      />
      {hasError && (
        <div className="error-message" style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
          {form.errors[field.name]}
        </div>
      )}
    </div>
  );
};

class CreatePieceVideo extends Component {
  state = {
    piece_id: '',
    video_file: '',
    video: '',
    file: {},
    awsKeys: {},
    disableUpload: false,
    piece: null,
    videoUploaded: false,
    isUploading: false,
  };

  onSubmit = (values) => {
    const { piece } = this.state;
    const piece_id = piece[0] && piece[0].id;
    const { quality_level } = values;
    this.props.onCreate({
      piece_id,
      video_file: this.state.video_file,
      quality_level: parseInt(quality_level, 10)
    });
  };

  onFileChange = async (eve) => {
    this.setState(prevState => ({
      ...prevState,
      videoUploaded: false,
      disableUpload: false,
    }));

    const file = eve.target.files[0];
    const getAwsKey = this.props.getAwsKey;
    const fileName = file.name.replace(/ /g, '_');
    const awsKeys = await getAwsKey({ key: `video/${fileName}` });

    this.setState(prevState => ({
      ...prevState,
      file,
      video_file: `${awsKeys.action}${awsKeys.key}`,
      awsKeys,
      disableUpload: true,
    }));
  };

  uploadVideo = async (eve) => {
    eve.preventDefault();
    if (!this.state.awsKeys.action) {
      toast.error('please try again.');
      return;
    }

    var form = document.querySelector('form[encType="multipart/form-data"]');
    var data = new FormData(form);

    try {
      this.setState(prevState => ({
        ...prevState,
        isUploading: true,
      }));

      await fetch(this.state.awsKeys.action, { method: 'POST', body: data });
      toast.success('Video uploaded successfully.');

      this.setState(prevState => ({
        ...prevState,
        videoUploaded: true,
        isUploading: false,
      }));
    } catch (error) {
      toast.error('Something went wrong while uploading video.');
      this.setState(prevState => ({
        ...prevState,
        isUploading: false,
      }));
    }
  };

  render() {
    const { isCreating, pieceVideoInfo } = this.props;
    const { awsKeys, file, disableUpload, piece, videoUploaded, isUploading } = this.state;

    return (
      <section className="well create-piece">
        <Formik
          initialValues={{
            quality_level: '',
          }}
          validationSchema={validationSchema}
          onSubmit={this.onSubmit}
        >
          {({ values, isValid, dirty }) => (
            <Form>
              <div className="row">
                <div className="col-md-3">
                  <label>Piece</label>
                </div>
                <div className="col-md-9">
                  <Typeahead
                    onChange={selected => {
                      this.setState({
                        piece: selected,
                      });
                    }}
                    labelKey="title"
                    options={pieceVideoInfo.pieces}
                    selected={piece}
                  />
                </div>

                <div className="col-md-3">
                  <label>Quality</label>
                </div>
                <div className="col-md-9">
                  <Field
                    name="quality_level"
                    placeholder="Quality Level"
                    component={CustomInput}
                    type="number"
                    className="form-control"
                    parentClass="form-group"
                  />
                </div>

                <div className="col-md-3">
                  <label>Media</label>
                </div>
                <div className="col-md-9">
                  <form method="post" encType="multipart/form-data" onSubmit={this.uploadVideo}>
                    <input type="hidden" name="key" value={awsKeys.key || 'NA'} />
                    <input type="hidden" name="acl" value={awsKeys.acl || 'NA'} />
                    <input type="hidden" name="X-Amz-Credential" value={awsKeys['x-amz-credential'] || 'NA'} />
                    <input type="hidden" name="X-Amz-Algorithm" value={awsKeys['x-amz-algorithm'] || 'NA'} />
                    <input type="hidden" name="X-Amz-Date" value={awsKeys['x-amz-date'] || 'NA'} />
                    <input type="hidden" name="Policy" value={awsKeys.policy || 'NA'} />
                    <input type="hidden" name="X-Amz-Signature" value={awsKeys['x-amz-signature'] || 'NA'} />
                    <input type="file" name="file" onChange={this.onFileChange} /> <br />
                    <input
                      type="submit"
                      name="submit"
                      value="Upload to Amazon S3"
                      className="btn btn-default"
                      disabled={!disableUpload}
                    />
                  </form>
                </div>

                <div className="create-piece__btn-container">
                  <button
                    className="btn btn-primary btn-block btn-lg"
                    type="submit"
                    disabled={
                      isCreating ||
                      isUploading ||
                      !isValid ||
                      !(piece && values.quality_level && videoUploaded)
                    }
                  >
                    {isCreating || isUploading ? (
                      <span className="spinner" />
                    ) : (
                      <span>Create</span>
                    )}
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </section>
    );
  }
}

export default CreatePieceVideo;
